<!--
 * @Author: 史金波
 * @Date: 2021-12-14 09:04:18
 * @LastEditors: 史金波
 * @Description: 
 * @LastEditTime: 2021-12-14 12:59:30
 * @FilePath: \saas-perform\src\views\account\accountrecharge.vue
-->
<template>
	<div>
		<el-breadcrumb separator-class="el-icon-arrow-right">
		  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
		  <el-breadcrumb-item>商家充值</el-breadcrumb-item>
		</el-breadcrumb>
		<el-form style="margin-top: 2.5rem" label-width="140px" :model="rechargeForm" ref="rechargeForm">
			<el-form-item label="充值账户" >
				预付款
			</el-form-item>
		  <el-form-item label="充值金额" prop="amount">
			<el-input size="small" v-model="rechargeForm.amount" auto-complete="off" placeholder="请输入部门代码" style="width: 25rem;"></el-input>
		  </el-form-item>
		  <el-form-item label="充值凭证" prop="contractUrl">
			<el-upload
			  class="upload-demo"
			  :action="uploadImgUrl"
			  :limit="1"
			  :file-list="contractFileList"
			  :on-success="uploadCallback"
			  list-type="picture" style="width: 29rem;">
			  <el-button size="small" type="primary">点击上传</el-button>
			  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
			</el-upload>
		  </el-form-item>
		  <el-form-item label="备注" prop="note">
				<el-input size="small" v-model="rechargeForm.note" auto-complete="off" placeholder="备注" style="width: 25rem;"></el-input>
		  </el-form-item>
		</el-form>
		<div slot="footer" style="align-items: center;" class="dialog-footer">
		  <el-button size="small">取消</el-button>
		  <el-button size="small" type="primary" class="title" @click="saveRechargeOrder()">保存</el-button>
		</div>
	</div>
</template>

<script>
	import {uploadSso} from "../../api/common.js"
	import {searchDistributesApi,submitRechargeOrderApi} from "../../api/recharge/rechargeApi.js"
	import { v4 as uuidv4 } from 'uuid'
	import {timestampToTime} from "../../utils/util.js"
	export default {
		data() {
			return {
				uniqId: uuidv4(),
				uploadImgUrl: "http://dev-api.cloudjoys.com/openapi/uploadFile",
				rechargeForm: {
					id: '',
					amount: '',
					note: '',
					enclosure:""
				},
				contractFileList: [],
				licenseFileList:[],
				contractFilePath:'',
				licenseFilePath:'',
				distributes:[]
			}
		},
		methods:{
			uploadCallback(res,file){
				if(res.code == 200){
					this.rechargeForm.enclosure = res.data.img;
					console.log("upload file :" + this.contractFilePath)
				}
			},
			saveRechargeOrder(){
				var orderParam = {
					amount: this.rechargeForm.amount,
					enclosure: this.rechargeForm.enclosure,
					note: this.rechargeForm.note,
					uniqId: this.uniqId,
					orderDate: timestampToTime(new Date().getTime()),
					orderType: 1
				}
				submitRechargeOrderApi(orderParam).then(res=>{
					if(res.data.code == '000000'){
						this.$router.push("/account/accountlist")
					}
				})
			}
		},
		created() {
		  
		},
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/account/accountrecharge.vue